import api, { isHTTPError } from '../api'
import useDataLoader from '../dataLoader'

const useCheckMergeAccount = () => {
  const checkMergeAccount = async (requestId: string, email: string) => {
    try {
        return await api.checkMergeAccounts(requestId, email)
      } catch (error) {
        if (isHTTPError(error) && error.response && 'detail' in error.response.data) {
          // @ts-ignore
          return error.response.data.detail.type
      }
    }
  }

  return useDataLoader(checkMergeAccount, [], [])
}

export default useCheckMergeAccount
